import { render, staticRenderFns } from "./IconTruckOutline.vue?vue&type=template&id=1bf18b92"
import script from "./IconTruckOutline.vue?vue&type=script&lang=js"
export * from "./IconTruckOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports